<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Custom Menus</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="customMenuAdd()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>

	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="venueService.subscriptionOOmenu.value"
		[loading]="!venueService.subscriptionOOmenu.value"
		[globalFilterFields]="app.keys(venueService.subscriptionOOmenu.value)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th>Name</th>
				<th>URL</th>
				<th>Default Menu</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr (click)="selectCustomMenu(rec)">
				<td>
					{{ rec.name }}
				</td>
				<td>
					<div *ngIf="!rec.unsaved">
						<span *ngIf="rec.key !== '0'">
							<a target="_blank" href="{{ baseUrl + '/' + venueService.subscriptionVenue.value.key + '?menuKey=' + rec.key }}">{{
								baseUrl + "/" + venueService.subscriptionVenue.value.key + "?menuKey=" + rec.key
							}}</a>
						</span>
						<span *ngIf="rec.key === '0'">
							<a target="_blank" href="{{ baseUrl + '/' + venueService.subscriptionVenue.value.key }}">{{
								baseUrl + "/" + venueService.subscriptionVenue.value.key
							}}</a>
						</span>
					</div>
				</td>
				<td>
					<span class="p-column-title">Default Menu</span>
					<p-inputSwitch [(ngModel)]="rec.active" (onChange)="onDefaultMenuChange(rec, rec.active)"></p-inputSwitch>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-custom-menu-record *ngIf="customMenuSelected" [(customMenuSelected)]="customMenuSelected"></app-custom-menu-record>
